import { makeVar } from '@apollo/client'

import { DepositsFilteredPayload } from 'services/Analytics/events/deposit'
import { TransactionsFilteredPayload } from 'services/Analytics/events/transaction'

export const rvDeferredFilterPayload = makeVar<
  TransactionsFilteredPayload | DepositsFilteredPayload
>({})
